<!--
~ Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
-->

<bci-master-detail-view
  [useDialog]="dialogToggle.checked">

  <!-- Master -->
  <bci-master-view>
    <h2 class="page-heading">Users</h2>

    <mat-slide-toggle #dialogToggle>Use Dialog?</mat-slide-toggle>

    <mat-list>
      <mat-list-item *ngFor="let user of service.items | async" [routerLink]="['.',site.id]">
        <mat-icon fontIcon="Bosch-Ic-user-outline" matListIcon></mat-icon>
        <span matLine>{{ site.name }} </span>
      </mat-list-item>
    </mat-list>
  </bci-master-view>

  <!-- Detail -->
  <bci-detail-view [isPadded]="true">
    <router-outlet></router-outlet>
  </bci-detail-view>

</bci-master-detail-view>
